module.exports = __webpack_public_path__ + "media/images/front/products/second_rate/product_1-6757c0074624af56927daa9f02065c58.jpg";